import { render, staticRenderFns } from "./indexKs.vue?vue&type=template&id=3fa4afc4&scoped=true&"
import script from "./indexKs.vue?vue&type=script&lang=js&"
export * from "./indexKs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa4afc4",
  null
  
)

export default component.exports